import React from 'react';
import Button from "../../../Button";
import { ChevronSmallLeft, ChevronSmallRight } from "../../../icons";
import { colorMap, directions } from '../../constants';
export var TechnicalMessageArrow = function TechnicalMessageArrow(_ref) {
  var onClick = _ref.onClick,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      direction = _ref.direction,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  return /*#__PURE__*/React.createElement(Button, {
    onClick: onClick,
    round: true,
    theme: "white",
    radius: 16,
    primary: true,
    color: colorMap[type],
    disabled: disabled
  }, direction === directions.next ? /*#__PURE__*/React.createElement(ChevronSmallRight, null) : /*#__PURE__*/React.createElement(ChevronSmallLeft, null));
};